import React from 'react';
import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';
import { SwiperSlide } from 'swiper/react';

import Slider from '../../../Slider';

import styles from './BlogSlider.styl';

import { useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

const cx = classNames.bind(styles);

export default function BlogSlider() {
  const intl = useIntl();
  const blog = useSelector(state => state.page.blog);
  const { list } = blog;
  const swiperParams = {
    slidesPerView: 'auto',
    spaceBetween: 16,
  };

  return (
    <div className={cx('BlogSlider')}>
      <Slider
        className={cx('UpsaleSlider__slider')}
        swiperParams={swiperParams}
      >
        {list?.map((item, index) => {

          return (
            <SwiperSlide className={cx('UpsaleSlider__slide')} key={index}>
              <div>
                <figure className={cx('UpsaleSlider__slide-image')}>
                  <img src={item.image} alt={'blog'} />
                </figure>
              </div>
              <div className={cx('UpsaleSlider__slide-container')}>
                <div>
                  <div className={cx('UpsaleSlider__slide-name')}>
                    {item.title}
                  </div>
                  <div className={cx('UpsaleSlider__slide-description')}>
                    {item.text}
                  </div>
                </div>

                <div className={cx('UpsaleSlider__slide-more')}>
                  <Link to={`/${item.url}`}>
                    {intl.formatMessage({ id: 'blog.more' })}
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Slider>
    </div>
  );
}
